import InputError from "@/components/InputError"
import Modal from "@/components/Modal"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import useApiBaseUrl from "@/hooks/useApiBaseUrl"
import useSessionStorage from "@/hooks/useSessionStorage"
import api from "@/lib/axios"
import { DataPenetapanUkt } from "@/types"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import { useState } from "react"
import toast from "react-hot-toast"
import { IoWarning } from "react-icons/io5"
import { LuDownload } from "react-icons/lu"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const uploadUlangSuratPernyataan = async (newData: FormData) => {
  const id_sys_periode = newData.get("id_sys_periode")
  const response = await api.post(
    `/siswa/daftar-kembali/data-berkas/upload-ulang-surat-pernyataan?id_sys_periode=${id_sys_periode}`,
    newData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
  return response.data
}

export default function FormTitipan({
  id_data_ukt_pendaftar_lulus,
  dataPenetapanUkt,
}: {
  id_data_ukt_pendaftar_lulus: string
  dataPenetapanUkt: DataPenetapanUkt | undefined
}) {
  const { apiBaseUrl } = useApiBaseUrl()
  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  })

  const [file, setFile] = useState<File | null>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0]
    if (file) setFile(file)
  }

  const queryClient = useQueryClient()
  const { mutate, isPending, error } = useMutation({
    mutationFn: uploadUlangSuratPernyataan,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["dataSiswaPengumuman"] })
      toast.success(data?.message || "Success.")
    },
    onError: (
      error: AxiosError<{ message?: string; errors?: Record<string, string[]> }>
    ) => {
      const err = error as AxiosError<{
        message?: string
        errors?: Record<string, string[]>
      }>
      const errorMessage =
        err.response?.data?.message || "An unexpected error occurred."
      toast.error(errorMessage)
    },
  })

  const handleUploadUlangSuratPernyataan = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault()

    const formData = new FormData()

    if (file) formData.append("file_surat_pernyataan", file)
    formData.append("id_sys_periode", sessionPeriode?.id_sys_periode)
    formData.append("id_data_ukt_pendaftar_lulus", id_data_ukt_pendaftar_lulus)

    mutate(formData)
  }

  return (
    <div>
      <Modal show={true} closeable={false}>
        <div>
          <Alert variant={"warning"}>
            <IoWarning />
            <AlertTitle>Perhatian!</AlertTitle>
            <AlertDescription>
              Maaf, penetapan besaran UKT belum dapat ditampilkan. Anda diminta
              untuk mengunggah ulang Surat Pernyataan Isian Data UKT. Silakan
              buat ulang surat pernyataan dan lakukan unggah ulang.
            </AlertDescription>
          </Alert>
          <form onSubmit={handleUploadUlangSuratPernyataan} className="mt-5">
            <div>
              {dataPenetapanUkt?.is_show_genrate_surat_pernyataan ? (
                <Button
                  type="button"
                  variant={"outline"}
                  className="w-full flex items-center gap-3"
                  onClick={() => {
                    window.open(
                      `${apiBaseUrl}/siswa/daftar-kembali/data-berkas/generate-format-sp?id_sys_periode=${sessionPeriode?.id_sys_periode}`
                    )
                  }}
                >
                  <LuDownload /> Generate Surat Pernyataan
                </Button>
              ) : (
                ""
              )}
              <Label>Surat Pernyataan</Label>
              <Input
                type="file"
                accept=".pdf, image/*"
                onChange={handleFileChange}
              />
              <InputError
                text={error?.response?.data?.errors?.file_surat_pernyataan?.join(
                  ","
                )}
              />
            </div>
            <div className="mt-10">
              <Button
                className="w-full flex items-center gap-3"
                disabled={isPending}
              >
                {isPending ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "Simpan"
                )}
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  )
}
